export function getBoundsCenter(bounds: number[][]) {
  const delta = [
    Math.abs(bounds[0][0] - bounds[1][0]) / 2,
    Math.abs(bounds[0][1] - bounds[1][1]) / 2,
  ];
  
  return [
    bounds[0][0] > bounds[1][0] ? bounds[1][0] + delta[0] : bounds[0][0] + delta[0],
    bounds[0][1] > bounds[1][1] ? bounds[1][1] + delta[1] : bounds[0][1] + delta[1],
  ];
}
